import BaseAPI from './base/base-api';

class ServiceRegisBankAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'PaymentAPI';
	controllerName = 'serviceRegisBank';
}

export default new ServiceRegisBankAPI();
